import React from "react";
import { StatusChip } from "@/shared/components/ui/Status/StatusChip";

const ProfileBehaviourCard = ({ title, desc, variant, firstCard, reason, lastcard }) => {
  return (
    <div
      className={`flex flex-col text-[0.763rem] font-medium leading-5 min-h-[52px] w-fit ${firstCard ? "pr-6" : "px-6"
        } gap-2 items-start ${!lastcard ? "border-r-[1px] border-r-gray-200 dark:border-r-gray-800" : ""}`}
    >
      <h3 className="text-gray-700 dark:text-gray-400 text-[0.763rem]">{title}</h3>
      <StatusChip
        label={desc}
        variant={variant}
        tooltipContent={reason}
        tooltipPlacement="right"
        className={"rounded-[4px] py-1 px-2 font-medium"}
      />
    </div>
  );
};

export default ProfileBehaviourCard;
